import React ,{useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import './SubCategory0.css';
import { Navigation } from "swiper/modules";
import { VscArrowRight, VscArrowLeft } from "react-icons/vsc";
import { Link } from "react-router-dom";



const SubCategory0 = ({data}) => {
   
    const baseImageUrl =
      "https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/";

const subcategories = data.get_home_component_details.content.map(
  (item, index) => ({
    id: item.subcategory_auto_id,
    name: item.sub_category_name,
    url: `/categorypage/${item.subcategory_auto_id}`,
    image: item.subcategory_image_app
      ? `${baseImageUrl}${item.subcategory_image_app}`
      : "https://via.placeholder.com/400", 
  })
);

 
    const truncateNameMobile = (name) => {
        return name.length > 15 ? name.substring(0, 15) + "..." : name;
    };

    const truncateNameDesktop = (name) => {
        return name.length > 25 ? name.substring(0, 25) + "..." : name;
    };
    const swiperRef_sc_0=useRef(null)

    return (
      <div
        className="p-2 "
        style={{
          backgroundColor: data.web_background_color,
        }}
      >
        {" "}
        {/* Padding on both sides */}
        <h2
          className={`text-${data.title_alignment} p-3 ${data.web_title_font}`}
          style={{
            color: data.web_title_color,
          }}
        >
          {data.title}
        </h2>
        {/* Desktop View: 4 Cards per Row, No Gap, Fully Rounded */}
        <div className="hidden lg:flex flex-wrap justify-center px-4 relative">
          <Swiper
            ref={swiperRef_sc_0}
            slidesPerView={4}
            spaceBetween={5}
            loop={subcategories.length > 4}
            watchOverflow={false}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {subcategories.map((category) => (
              <SwiperSlide key={category.id} style={{ minWidth: "450px" }} >
                <div className="flex justify-center">
                  <div className="text-center flex items-center relative">
                    <Link
                      to="/productlist"
                      state={{
                        subcategoryName: category.name,
                        sub_cat_id: category.id,
                      }}
                      className="text-decoration-none flex flex-col items-center"
                    >
                      <img
                        src={category.image}
                        alt={category.name}
                        className="rounded-lg object-cover"
                        style={{ height: "580px", width: "auto" }}
                      />
                      <div className="absolute inset-0 bg-gray-800/30 rounded"></div>
                      <div
                        className={`absolute top-1/2 left-1/2 -translate-x-1/2 text-white text-3xl font-bold uppercase text-center drop-shadow-lg ${data.web_title_font}`}
                      >
                        {truncateNameDesktop(category.name)}
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {subcategories.length > 4 && (
            <>
              <div className={`swiper-button-prev-${data._id} swiper-button-prev-1 mx-20 p-2`}>
                <VscArrowLeft size={24} />
              </div>
              <div className={`swiper-button-next-${data._id} swiper-button-next-1 mx-20 p-2`}>
                <VscArrowRight size={24} />
              </div>
            </>
          )}
        </div>
        {/* Mobile View: Rounded Carousel with 4 Items */}
        <div className="grid grid-cols-2 gap-2 lg:hidden justify-center ">
          {subcategories.map((category) => (
            <div key={category.id} className="relative text-center">
              <Link
                to="/productlist"
                state={{
                  subcategoryName: category.name,
                  sub_cat_id: category.id,
                }}
                className="flex flex-col items-center"
              >
                {/* Fully Rounded Image */}
                <img
                  src={category.image}
                  alt={category.name}
                  className="rounded object-cover"
                  style={{ height: "280px", width: "auto" }}
                />
                {/* Black Overlay (30% Opacity) */}
                <div className="absolute inset-0 bg-gray-800/30 rounded"></div>
                {/* Name Overlay Centered Over Image */}
                <div
                  className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-lg font-bold uppercase drop-shadow-lg ${data.web_title_font}`}
                >
                  {truncateNameMobile(category.name)}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
};

export default SubCategory0; 